module.exports = __webpack_public_path__ + "img/0x577a51f7d39162c9de1db12a6b319c848e4c54e5.30d1df6c.png";